import React, { memo } from 'react';
import WorkInfoRowBase, { PrimaryBlock, PrimaryText, WorkInfoRowProps } from './WorkInfoRowBase';

const WorkInfo: React.FC<WorkInfoRowProps> = (props) => (
  <WorkInfoRowBase {...props}>
    {({ title, isHover, isActive }) => (
      <PrimaryBlock $isHover={isHover} $isActive={isActive}>
        <PrimaryText>{title}</PrimaryText>
      </PrimaryBlock>
    )}
  </WorkInfoRowBase>
);

export default memo(WorkInfo);
